import { Analytics } from '@util/Analytics';
import { translate } from '@util/Localization';
import React, { FunctionComponent } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';
import styled from 'styled-components';
import { iosBadge, playBadge } from './assets/images/Logos';

/** Displays one or two buttons with links to download from Apple App Store and Google Play */
export const DownloadAppButtons: FunctionComponent = () => (
  <>
    {isAndroid || <IosButton />}
    {isIOS || <AndroidButton />}
  </>
);

const AndroidButton: FunctionComponent = () => (
  <Button
    src={playBadge}
    alt="Get it on Google Play"
    linkTranslateKey="links.androidStore"
    store="gplay"
  />
);

const IosButton: FunctionComponent = () => (
  <Button
    src={iosBadge}
    alt="Download on the App Store"
    linkTranslateKey="links.iosStore"
    store="apple"
  />
);

type ButtonProps = {
  src: string;
  alt: string;
  linkTranslateKey: string;
  store: 'apple' | 'gplay'; // For analytics events
};

const Button: FunctionComponent<ButtonProps> = (props) => {
  function track() {
    Analytics.track({
      event: Analytics.Event.o_app_store_opened,
      store: props.store,
    });
  }

  return (
    <a href={translate(props.linkTranslateKey)} onClick={track}>
      <Image src={props.src} alt={props.alt} />
    </a>
  );
};

const Image = styled.img`
  width: 140px;
  height: 45px;
  display: block;
`;
